import { createContext, useState, useContext, ReactNode, FC } from 'react';

interface ContexteProps {
    isGameStarted: boolean;
    toggleGame: (value: boolean) => void;
}

const InTheGameContext = createContext<ContexteProps | undefined>(undefined);

interface InTheGameProviderProps {
    children: ReactNode;
}

export const InTheGameProvider: FC<InTheGameProviderProps> = ({ children }) => {
    const [isGameStarted, setIsGameStarted] = useState(false);

    const toggleGame = (value: boolean) => {
        setIsGameStarted(value);
    };

    return (
        <InTheGameContext.Provider value={{ isGameStarted, toggleGame }}>
            {children}
        </InTheGameContext.Provider>
    );
};

export const useInTheGame = () => {
    const context = useContext(InTheGameContext);
    if (context === undefined) {
        throw new Error('useInTheGame doit être utilisé dans un InTheGameProvider');
    }
    return context;
};
